import * as React from "react";
import {
  Body,
  Button,
  Container,
  Head,
  Heading,
  Html,
  Preview,
  Section,
  Text,
  Link,
  Img,
} from "@react-email/components";
import { render } from "@react-email/render";
import { VehiclePhoto } from '@otw/models';

export interface VehiclePhotosEmailProps {
  vehicleInfo: string;
  message: string;
  photos: VehiclePhoto[];
  zipUrl?: string; // Optional URL to the ZIP
}

export const vehiclePhotosEmail = async (
  params: VehiclePhotosEmailProps
): Promise<{ subject: string; html: string }> => {
  const { vehicleInfo, message, photos } = params;

  const subject = `Vehicle Photos: ${vehicleInfo}`;

  // Create the email content as a plain HTML string instead of using React components
  const html = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>${subject}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
      </head>
      <body style="font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif; background-color: #f5f5f5; margin: 0; padding: 0;">
        <div style="max-width: 600px; margin: 0 auto; background-color: #ffffff; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 40px; margin-bottom: 40px;">
          <div style="padding: 32px; text-align: center; border-bottom: 1px solid #e0e0e0;">
            <img src="https://firebasestorage.googleapis.com/v0/b/otw-production-91ffb.appspot.com/o/public%2FLogoVariation-OpticTruckWorks-05.png?alt=media&token=c3428c05-276c-4d32-ac33-a7d9d51fe380" alt="Optic Truck Works Logo" style="max-width: 200px; height: auto; margin: 0 auto;">
          </div>
          <div style="padding: 32px;">
            <h1 style="font-size: 24px; font-weight: 500; color: #1976d2; margin-bottom: 24px; text-align: center;">
              Vehicle Photos: ${vehicleInfo}
            </h1>
            <p style="font-size: 16px; color: #333333; line-height: 1.6; margin-bottom: 16px;">
              Hi,
            </p>
            <p style="font-size: 16px; color: #333333; line-height: 1.6; margin-bottom: 24px; white-space: pre-line;">
              ${message}
            </p>
            <p style="font-size: 16px; color: #333333; line-height: 1.6; margin-bottom: 16px;">
              Please find attached photos for this vehicle. Total photos included: ${photos.length}
            </p>
            <p style="font-size: 16px; color: #333333; line-height: 1.6; margin-bottom: 24px;">
              If you have any questions or would like to schedule a viewing, please let us know.
            </p>
            <p style="font-size: 16px; color: #333333; line-height: 1.6; margin-bottom: 16px;">
              If you need assistance, please contact our team at
              <a href="mailto:sales@optictruckworks.com" style="color: #1976d2; text-decoration: underline;">
                sales@optictruckworks.com
              </a>
            </p>
            <p style="font-size: 16px; color: #666666; line-height: 1.6; border-top: 1px solid #e0e0e0; padding-top: 24px;">
              Best regards,<br>
              The Optic Truck Works Team
            </p>
          </div>
        </div>
      </body>
    </html>
  `;

  return {
    subject,
    html,
  };
};

export default vehiclePhotosEmail;
